import { render, staticRenderFns } from "./WarehousesStatistics.vue?vue&type=template&id=27d506f3"
import script from "./WarehousesStatistics.vue?vue&type=script&lang=js"
export * from "./WarehousesStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports